import { handlePuzzelCallback } from "app/PuzzelAuth/puzzelAuth";
import {
  getValidPuzzelAccessToken,
  setPuzzelLoginError,
} from "app/PuzzelAuth/puzzelTokenStorage";
import { TrainLoader } from "app/TrainLoader";
import { log, LogLevel } from "logging/datadogBrowserLogs";
import { FC, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

export const PuzzelCallback: FC = () => {
  const navigate = useNavigate();
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) {
      return;
    }
    hasRun.current = true;

    const completeLogin = async () => {
      try {
        const returnPath = await handlePuzzelCallback();
        void navigate(returnPath, { replace: true });
      } catch (error) {
        log(
          LogLevel.error,
          "PuzzelCallback",
          "Failed to complete Puzzel login",
          error,
        );
        if (!getValidPuzzelAccessToken()) {
          setPuzzelLoginError();
        }
        void navigate("/", { replace: true });
      }
    };

    void completeLogin();
  }, [navigate]);

  return <TrainLoader />;
};
